import CalendarEventsStoreIndex from './schema/CalendarEventsStoreIndex';
import CalendarInfoStoreIndex from './schema/CalendarInfoStoreIndex';
import { Calendar } from 'mini-event-to-calendar-association/lib/schema/Calendar';
import { CalendarEvent } from 'mini-calendar-event-types';

export default class CalendarFolderItemIdIndex
    implements CalendarEventsStoreIndex, CalendarInfoStoreIndex {
    private folderIdItemIdMap: Map<string, Set<string>>;
    private folderIdLastOpTimestampMap: Map<string, number>;

    constructor() {
        this.folderIdItemIdMap = new Map<string, Set<string>>();
        this.folderIdLastOpTimestampMap = new Map<string, number>();
    }

    private addFolderId(folderId: string) {
        this.folderIdItemIdMap.set(folderId, new Set<string>());
    }

    private deleteFolderId(folderId: string) {
        this.folderIdItemIdMap.delete(folderId);
    }

    getFolderIdLastOpTimestampMap() {
        return this.folderIdLastOpTimestampMap;
    }

    addItemId(folderId: string, itemId: string) {
        if (this.folderIdItemIdMap.has(folderId)) {
            this.folderIdItemIdMap.get(folderId).add(itemId);
            this.folderIdLastOpTimestampMap.set(folderId, Date.now());
        }
    }

    deleteItemId(folderId: string, itemId: string) {
        if (this.folderIdItemIdMap.has(folderId)) {
            this.folderIdItemIdMap.get(folderId).delete(itemId);
            this.folderIdLastOpTimestampMap.set(folderId, Date.now());
        }
    }

    deleteAllItems(folderId: string) {
        if (this.folderIdItemIdMap.has(folderId)) {
            this.folderIdItemIdMap.get(folderId).clear();
        }
    }

    getAllItemIds(folderId: string): string[] {
        let itemIds: string[] = [];
        if (this.folderIdItemIdMap.has(folderId)) {
            itemIds = this.folderIdItemIdMap.get(folderId).keys();
        }
        return [...itemIds];
    }

    onAddCalendarEvent(event: CalendarEvent): void {
        event.ParentFolderId &&
            event.ItemId &&
            this.addItemId(event.ParentFolderId.Id, event.ItemId.Id);
    }

    onDeleteCalendarEvent(event: CalendarEvent): void {
        event.ParentFolderId &&
            event.ItemId &&
            this.deleteItemId(event.ParentFolderId.Id, event.ItemId.Id);
    }

    clearIndex() {
        this.folderIdItemIdMap.forEach((value, folderId) => this.deleteAllItems(folderId));
    }

    onAddCalendarInfo(calendar: Calendar): void {
        calendar && this.addFolderId(calendar.calculatedFolderId);
    }

    onDeleteCalendarInfo(calendar: Calendar): void {
        calendar && this.deleteFolderId(calendar.calculatedFolderId);
    }
}
